import Button from 'react-bootstrap/Button'
import './buttons.scss'

function CallButton({ text, icon }) {
    return (
        <Button className='call-button'><span>{icon}</span>{text}</Button>
    )
}

export default CallButton